var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17338_71299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50049 6.50024V9.16691M8.50049 11.8335H8.50716M7.3605 3.07347L1.71384 12.5001C1.59741 12.7018 1.53581 12.9303 1.53516 13.1631C1.53451 13.396 1.59483 13.6249 1.71012 13.8272C1.82541 14.0294 1.99165 14.198 2.19231 14.316C2.39296 14.4341 2.62104 14.4976 2.85384 14.5001H14.1472C14.38 14.4976 14.608 14.4341 14.8087 14.316C15.0094 14.198 15.1756 14.0294 15.2909 13.8272C15.4062 13.6249 15.4665 13.396 15.4658 13.1631C15.4652 12.9303 15.4036 12.7018 15.2872 12.5001L9.6405 3.07347C9.52165 2.87754 9.35432 2.71555 9.15463 2.60313C8.95495 2.4907 8.72966 2.43164 8.5005 2.43164C8.27134 2.43164 8.04606 2.4907 7.84637 2.60313C7.64669 2.71555 7.47935 2.87754 7.3605 3.07347V3.07347Z",
    stroke: "#AF5304",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17338_71299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.67bb6387f038d2367b781fca3c4973e3.svg";
export { ForwardRef as ReactComponent };